/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionLeadAdmissionStatusInfo } from './PalAuthSubmissionLeadAdmissionStatusInfo';
import {
    PalAuthSubmissionLeadAdmissionStatusInfoFromJSON,
    PalAuthSubmissionLeadAdmissionStatusInfoFromJSONTyped,
    PalAuthSubmissionLeadAdmissionStatusInfoToJSON,
} from './PalAuthSubmissionLeadAdmissionStatusInfo';
import type { PalAuthSubmissionLeadScreenerLeadInfoRace } from './PalAuthSubmissionLeadScreenerLeadInfoRace';
import {
    PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSON,
    PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSONTyped,
    PalAuthSubmissionLeadScreenerLeadInfoRaceToJSON,
} from './PalAuthSubmissionLeadScreenerLeadInfoRace';
import type { PalSubmissionListEntryLeadAllOfAssignmentsInner } from './PalSubmissionListEntryLeadAllOfAssignmentsInner';
import {
    PalSubmissionListEntryLeadAllOfAssignmentsInnerFromJSON,
    PalSubmissionListEntryLeadAllOfAssignmentsInnerFromJSONTyped,
    PalSubmissionListEntryLeadAllOfAssignmentsInnerToJSON,
} from './PalSubmissionListEntryLeadAllOfAssignmentsInner';

/**
 * 
 * @export
 * @interface PalReauthSubmissionListEntryLead
 */
export interface PalReauthSubmissionListEntryLead {
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntryLead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntryLead
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntryLead
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntryLead
     */
    admission_status?: string | null;
    /**
     * 
     * @type {PalAuthSubmissionLeadAdmissionStatusInfo}
     * @memberof PalReauthSubmissionListEntryLead
     */
    admission_status_info?: PalAuthSubmissionLeadAdmissionStatusInfo;
    /**
     * 
     * @type {PalAuthSubmissionLeadScreenerLeadInfoRace}
     * @memberof PalReauthSubmissionListEntryLead
     */
    facility?: PalAuthSubmissionLeadScreenerLeadInfoRace;
    /**
     * 
     * @type {Array<PalSubmissionListEntryLeadAllOfAssignmentsInner>}
     * @memberof PalReauthSubmissionListEntryLead
     */
    assignments?: Array<PalSubmissionListEntryLeadAllOfAssignmentsInner>;
}

/**
 * Check if a given object implements the PalReauthSubmissionListEntryLead interface.
 */
export function instanceOfPalReauthSubmissionListEntryLead(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalReauthSubmissionListEntryLeadFromJSON(json: any): PalReauthSubmissionListEntryLead {
    return PalReauthSubmissionListEntryLeadFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryLeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntryLead {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'admission_status': !exists(json, 'admission_status') ? undefined : json['admission_status'],
        'admission_status_info': !exists(json, 'admission_status_info') ? undefined : PalAuthSubmissionLeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
        'facility': !exists(json, 'facility') ? undefined : PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSON(json['facility']),
        'assignments': !exists(json, 'assignments') ? undefined : ((json['assignments'] as Array<any>).map(PalSubmissionListEntryLeadAllOfAssignmentsInnerFromJSON)),
    };
}

export function PalReauthSubmissionListEntryLeadToJSON(value?: PalReauthSubmissionListEntryLead | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'admission_status': value.admission_status,
        'admission_status_info': PalAuthSubmissionLeadAdmissionStatusInfoToJSON(value.admission_status_info),
        'facility': PalAuthSubmissionLeadScreenerLeadInfoRaceToJSON(value.facility),
        'assignments': value.assignments === undefined ? undefined : ((value.assignments as Array<any>).map(PalSubmissionListEntryLeadAllOfAssignmentsInnerToJSON)),
    };
}

